<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2025-05-20 20:59:55
 * @LastEditors: ???
 * @LastEditTime: 2025-05-20 14:42:18
-->
<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="订单编号">
          <el-input v-model="queryParam.orderNo"></el-input>
        </el-form-item>
        <el-form-item label="满意度">
          <el-select
            v-model="queryParam.socre"
            clearable
            filterable
          >
            <el-option
              v-for="item in socreOpts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="评价时间">
          <el-date-picker
            style="width: 350px"
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateRangeChange"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <!-- <el-button type="primary" @click="handleExportXls">导出</el-button> -->
          <div class="exportSelectBox">
            <el-select value="更多" size="mini" @change="selectExport">
              <el-option value="/user/statistical/bookingOrder/export" label="导出"></el-option>
            </el-select>
          </div>

        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #socreSlot="slotData">
          <span v-if="slotData.data.row.socre == 0"> 满意 </span>
          <span v-if="slotData.data.row.socre == 1"> 一般 </span>
          <span v-if="slotData.data.row.socre == 2"> 不满意 </span>
      </template>
    </e-table>
    

    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
    <remarkModal ref="remark" @ok="searchQuery"></remarkModal>
    <orderTimeModal ref="time" @ok="searchQuery"></orderTimeModal>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import { getLast7Days } from '@/utils/util'

import eTable from '@/components/table'
import { listMixin } from '@/mixins/listMixin'
import { postAction, getAction } from '@/api/manage'

export default {
  components: { eTable },
  mixins: [listMixin],
  props: {},
  data () {
    return {
      socreOpts: [
        { value: 0, label: "满意" },
        { value: 1, label: "一般" },
        { value: 2, label: "不满意" },
      ],
      summaryData: {},
      dateRange: [],
      deleteKey: 'userId',
      url: {
        list: '/wlOrderComment/queryPage',
        exportXlsUrl: 'user/statistical/bookingOrder/export',
      },
      queryParam: {
        status: 0,
      },
      //字段权限
      columns: [
        { field: 'orderNo', label: '订单编号', width: 160 },
        { field: 'phone', label: '用户电话' },
        { label: '满意度',
          slotName: "socreSlot",
          columnType: "slot"},
        { field: 'comment', label: '评论内容'},
        { field: 'createTime', label: '评价时间'},
      ],
    }
  },
  watch: {},
  computed: {},
  methods: {
    selectExport (e) {
      if (!this.queryParam.beginTime && !this.queryParam.endTime) return this.$message.warning("请选择日期后导出")
      let newName = ''
      if (e === "/user/statistical/bookingOrder/export") newName = '导出'
      if (e === "/user/statistical/exportCancelOrder") newName = '导出取消订单'
      this.handleExportXls(newName, e)
    },
    searchReset () {
      this.queryParam = {
        status: '0',
      }
      this.initDictConfig()
      this.loadData(1)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.isOnTime === 1) {
        return 'danger-row'
      }
      return ''
    },
    dateRangeChange (val) {
      if (val) {
        this.queryParam.beginTime = val[0]
        this.queryParam.endTime = val[1]
      } else {
        this.queryParam.beginTime = ''
        this.queryParam.endTime = ''
      }
    },
    initDictConfig () {
      this.dateRange = getLast7Days()
      this.dateRangeChange(this.dateRange)
    },
    fetchData () {
      console.log(this.ipagination.page)
    },
    add (val) {
      console.log(val)
    },
    edit (val) { },
    del (val) { },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
}
.exportSelectBox {
  display: inline-block;
  margin-left: 10px;
  /deep/.el-input input {
    background: #409eff;
    color: white;
    width: 70px;
    height: 28px;
  }
}
</style>
